export const BUILD_VERSION = '1787747048';
